<script setup lang="ts">
import type { IJournalTopic } from '@/entities/journal/model/types';

withDefaults(defineProps<{ topics?: IJournalTopic[] }>(), {
  topics: () => [],
});
</script>

<template>
  <ul class="chief-editor-card-topics">
    <li v-for="topic in topics" :key="topic.id" class="chief-editor-card-topics__item">
      {{ topic.name }}
    </li>
  </ul>
</template>

<style lang="less">
.chief-editor-card-topics {
  display: inline-flex;
  flex-wrap: wrap;
  gap: @main-size;

  &__item {
    display: inline-flex;
    padding: 5px;
    min-height: 26px;
    text-align: left;
    background-color: @color-black-haze;
    border-radius: @main-size;
    font-weight: 600;
    font-size: @size-x3;
    line-height: @size-x4;
  }
}
</style>
